import { Component } from '@angular/core';

import { AppSessionService, DialogsService } from '@services';
import { NavigationEnd, Router } from '@angular/router';
import { BitfDynamicLocaleService } from '@common/libs/bitforce/core/services/locale/bitf-dynamic-locale.service';
import { CONSTANTS } from './constants';
import { BitfMetadataService } from '@common/libs/bitforce/core/services/metadata/bitf-metadata.service';
import { NewsletterDialogComponent } from './shared/newsletter-dialog/newsletter-dialog.component';
import { EBitfCloseEventStatus } from './enums';
import { IBitfCloseEvent } from './interfaces';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private appSessionService: AppSessionService,
    private router: Router,
    private bitfMetadataService: BitfMetadataService,
    private bitfDynamicLocaleService: BitfDynamicLocaleService,
    private dialogsService: DialogsService
  ) {
    this.appSessionService.init().then(() => {
      this.setLocale();

      router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.setLocale();
          this.bitfMetadataService.setCanonical();
        }
      });

      if (!location.href.includes('localhost')) {
        // Iubenda
        window['_iub'] = window['_iub'] || [];
        window['_iub'].csConfiguration = {
          ccpaAcknowledgeOnDisplay: true,
          consentOnContinuedBrowsing: false,
          countryDetection: true,
          enableCcpa: true,
          enableLgpd: true,
          floatingPreferencesButtonDisplay: false,
          invalidateConsentWithoutLog: true,
          lgpdAppliesGlobally: false,
          perPurposeConsent: true,
          siteId: 2807610,
          whitelabel: false,
          cookiePolicyId: 21518436,
          lang: bitfDynamicLocaleService.locale.code,
          banner: {
            acceptButtonDisplay: true,
            closeButtonDisplay: false,
            customizeButtonDisplay: true,
            explicitWithdrawal: true,
            listPurposes: true,
            position: 'float-bottom-center',
            rejectButtonDisplay: true,
          },
        };

        const iubendaStubScript = document.createElement('script');
        iubendaStubScript.src = '//cdn.iubenda.com/cs/ccpa/stub.js';
        document.head.appendChild(iubendaStubScript);

        const iubendaCsScript = document.createElement('script');
        iubendaCsScript.src = '//cdn.iubenda.com/cs/iubenda_cs.js';
        document.head.appendChild(iubendaCsScript);

        // FB messenger
        // const fjs = document.getElementById('fbInitScript');
        // const js = document.createElement('script');
        // js.id = 'facebook-jssdk';
        // js.src = `https://connect.facebook.net/${
        //   bitfDynamicLocaleService.locale.code === 'it' ? 'it_IT' : 'en_US'
        // }/sdk/xfbml.customerchat.js`;
        // fjs.parentNode.append(js);
      }

      setTimeout(() => {
        this.handleNewsletterDialog();
      }, 30000);
    });
  }

  private handleNewsletterDialog() {
    const cciNewsletterStorage = localStorage.getItem('cci-newsletter');
    const now = Date.now();
    const expiration = new Date(cciNewsletterStorage);
    if (!cciNewsletterStorage || expiration.getTime() > expiration.getTime()) {
      this.openNewsletterDialog();
    }
  }

  private openNewsletterDialog() {
    const dialogRef = this.dialogsService.dialog.open(NewsletterDialogComponent, {
      width: '500px',
      // minWidth: '600px',
      maxWidth: '90%',
      // height: '90%',
      // maxHeight: '80%',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result: IBitfCloseEvent<void>) => {
      //  NOTE: in case the user subscribe we'll add 10 years otherwise we'll add 1 months
      const expirationDate = new Date();
      if (result?.status === EBitfCloseEventStatus.OK) {
        expirationDate.setTime(expirationDate.getTime() + 3650 * 24 * 60 * 60 * 1000);
      } else {
        expirationDate.setTime(expirationDate.getTime() + 31 * 24 * 60 * 60 * 1000);
      }
      localStorage.setItem('cci-newsletter', expirationDate.toISOString());
    });
  }

  private setLocale() {
    if (location.pathname === '/') {
      this.router.navigate([`/${this.bitfDynamicLocaleService.locale.code}`]);
    } else if (location.pathname.includes('/it/')) {
      this.bitfDynamicLocaleService.setLocale(CONSTANTS.SUPPORTED_LANGUAGES[0]);
    } else if (location.pathname.includes('/en/')) {
      this.bitfDynamicLocaleService.setLocale(CONSTANTS.SUPPORTED_LANGUAGES[1]);
    }
  }
}
